import {string} from "@src/libs/yup";

export default string().min(6, "Password must be at least 6 characters").required("Please enter a password");